module.exports = __webpack_public_path__ + "img/104.0b2a50fc.jpg";